import { render, staticRenderFns } from "./AddCableToProductModal.vue?vue&type=template&id=0ed36386&"
import script from "./AddCableToProductModal.vue?vue&type=script&lang=js&"
export * from "./AddCableToProductModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports